import React from "react";
import { 
  Accordion as BSAccordion,
  AccordionProps as BSAccordionProps,
  AccordionHeaderProps as BSAccordionHeaderProps
} from "react-bootstrap";

function AccordionHeader({ children, ...props }: BSAccordionHeaderProps) {
  return (
    <BSAccordion.Header {...props}>
      <span className="accordion-label">{children}</span>
      <span className="accordion-icon" aria-hidden="true">
        {/* PLUS icon */}
        <svg
          className="icon plus"
          data-testid="accordion-plus-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          focusable="false"
        >
          <path d="M12 5v14M5 12h14" />
        </svg>

        {/* MINUS icon */}
        <svg
          className="icon minus"
          data-testid="accordion-minus-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          focusable="false"
        >
          <path d="M5 12h14" />
        </svg>
      </span>
    </BSAccordion.Header>
  );
}

export function Accordion({ children, ...props }: BSAccordionProps) {
  return (
    <BSAccordion className="k12-accordion" {...props}>
      {children}
    </BSAccordion>
  );
}

export default Object.assign(Accordion, {
  Item: BSAccordion.Item,
  Header: AccordionHeader,
  Body: BSAccordion.Body
});
